// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/*
 request.map of Tks
  GetAll,
  Create,
  GetById,
  Update,
  Delete
*/

// ## Tks Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Tks.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Tks Create
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Tks.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Tks Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Tks.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Tks Calculate
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Calculate = async (form, option) => {
  const response = await $api.post(Endpoints.Tks.Calculate(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Tks Get Capacity By Device
/**
 *
 * @param {{params: { id: string }, query: object}} form
 
 * @returns
 */
export const GetCapacityByDevice = async (form) => {
  const response = await $api.post(Endpoints.Tks.GetCapacityByDevice(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Tks Get Device Names
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetDeviceNames = async (option) => {
  const response = await $api.get(Endpoints.Tks.GetDeviceNames(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Tks Get Grain Names
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetGrainNames = async (option) => {
  const response = await $api.get(Endpoints.Tks.GetGrainNames(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Tks Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Tks.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Calculate,
  GetCapacityByDevice,
  GetDeviceNames,
  GetGrainNames,
  Delete,
};
